<template>
  <div class="manage-default-box">
    <div class="main-box clear-both">
      <LeftNav :status='2'></LeftNav>
      <div class="customer-list-box">
        <h2>会員一覧</h2>
        <div class="search-box">
          <p class="title">検索<br />条件</p>
          <div class="search-content-box">
            <div class="search-sub-box">
              <dl>
                <dt class="customer-id">会員ID</dt>
                <dd>
                  <input type="text" class="search_input" v-model="search_customer_id">
                </dd>
              </dl>
              <dl>
                <dt class="customer-name">会員名</dt>
                <dd>
                  <input type="text" class="search_input" v-model="search_customer_name">
                </dd>
              </dl>
            </div>
            <div class="search-sub-box">
              <dl>
                <dt class="select-not-purchased">未購入期間</dt>
                <dd>
                  <select name="select-not-purchased" class="select-not-purchased" v-model="search_select_not_purchased">
                    <option v-for="item in select_box_list" :key="item.id" :value="item.value" :id="item.id">{{ item.text }}</option>
                  </select>
                </dd>
              </dl>
              <dl>
                <dt class="select-not-purchased">未送信期間</dt>
                <dd>
                  <select name="select-not-purchased" class="select-not-purchased" v-model="search_select_not_mail">
                    <option v-for="item in select_mail_box_list" :key="item.id" :value="item.value" :id="item.id">{{ item.text }}</option>
                  </select>
                </dd>
              </dl>
              <dl>
                <dt class="select-not-purchased">都道府県</dt>
                <dd>
                  <select name="select-not-purchased" class="select-not-purchased" v-model="search_select_prefecture">
                    <option v-for="item in select_prefecture_box_list" :key="item.id" :value="item.value" :id="item.id">{{ item.text }}</option>
                  </select>
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <div class="customer-info-box">
          <div class="num-box">
            <div class="customers-num-box">
              <p class="title">会員数：</p>
              <p class="num-info">{{ search_num }}/{{ list_all_num }}</p>
            </div>
            <div class="button" @click="check_clear">チェックをクリア</div>
            <div class="button" @click="mail_send">チェック付けた会員にメール送信（ {{ check_num }} 件 ）</div>
          </div>
          <div v-if="page_all_num > 1" class="paging-box">
            <div @click="page_shift(-1)">＜</div>
            <input type="text" v-model="page_num" @change="page_change()">
            <p>／</p>
            <p>{{ page_all_num }}</p>
            <div @click="page_shift(1)">＞</div>
          </div>
        </div>
        <div class="list-box">
          <table>
            <thead>
              <tr>
                <th v-for="item in list_head" :key="item.id" :class="item.class">{{ item.title }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in page_list" :key="item.id" :class="{'unsubscribe': item.deleted_date !== ''}">
                <td class="td-check">
                  <div v-if="item.deleted_date === ''">
                    <input :id="'check' + item.id" type="checkbox" v-model="check_list[item.id]">
                    <label :for="'check' + item.id"></label>
                  </div>
                </td>
                <td class="td-id">{{ item.id }}</td>
                <td class="td-name">
                  <div @click="user_detail_disp(item.id)">
                    <span v-if="item.deleted_date !== ''">[退会]</span>
                    <span>{{ item.customer_name }}</span>
                  </div></td>
                <td class="td-prefecture">{{ item.prefecture }}</td>
                <td class="td-last-order-date" v-html="date_br(item.last_order_date)"></td>
                <td class="td-last-send-date" v-html="date_br(item.last_send_mail_date)"></td>
                <td class="td-mail">{{ item.mail }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftNav from '@/views/components/manage/LeftNav';

export default {
  name: 'manageDefault',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    LeftNav,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      current_tab_id: 1,
      page_num: 1,
      step: 500,// 1ページの表示数
      list: [],
      select_box_list: [
        {id: 1, value: 'all', text: 'すべて'},
        {id: 2, value: 'one_month', text: '１ヶ月以上２か月未満'},
        {id: 3, value: 'two_month', text: '２ヶ月以上３か月未満'},
        {id: 4, value: 'three_month', text: '３ヶ月以上４か月未満'},
        {id: 5, value: 'four_month', text: '４ヶ月以上５か月未満'},
        {id: 6, value: 'five_month', text: '５ヶ月以上６か月未満'},
        {id: 7, value: 'six_month', text: '６ヶ月以上'}
      ],
      select_mail_box_list: [
        {id: 1, value: 'all', text: 'すべて'},
        {id: 2, value: 'one_month', text: '１ヶ月以上２か月未満'},
        {id: 3, value: 'two_month', text: '２ヶ月以上３か月未満'},
        {id: 4, value: 'three_month', text: '３ヶ月以上４か月未満'},
        {id: 5, value: 'four_month', text: '４ヶ月以上５か月未満'},
        {id: 6, value: 'five_month', text: '５ヶ月以上６か月未満'},
        {id: 7, value: 'six_month', text: '６ヶ月以上'}
      ],
      select_prefecture_box_list: [
        {id: 0, value: 'all', text: 'すべて'},
        {id: 1, value: '北海道', text: '北海道'},
        {id: 2, value: '青森県', text: '青森県'},
        {id: 3, value: '岩手県', text: '岩手県'},
        {id: 4, value: '宮城県', text: '宮城県'},
        {id: 5, value: '秋田県', text: '秋田県'},
        {id: 6, value: '山形県', text: '山形県'},
        {id: 7, value: '福島県', text: '福島県'},
        {id: 8, value: '茨城県', text: '茨城県'},
        {id: 9, value: '栃木県', text: '栃木県'},
        {id: 10, value: '群馬県', text: '群馬県'},
        {id: 11, value: '埼玉県', text: '埼玉県'},
        {id: 12, value: '千葉県', text: '千葉県'},
        {id: 13, value: '東京都', text: '東京都'},
        {id: 14, value: '神奈川県', text: '神奈川県'},
        {id: 15, value: '新潟県', text: '新潟県'},
        {id: 16, value: '富山県', text: '富山県'},
        {id: 17, value: '石川県', text: '石川県'},
        {id: 18, value: '福井県', text: '福井県'},
        {id: 19, value: '山梨県', text: '山梨県'},
        {id: 20, value: '長野県', text: '長野県'},
        {id: 21, value: '岐阜県', text: '岐阜県'},
        {id: 22, value: '静岡県', text: '静岡県'},
        {id: 23, value: '愛知県', text: '愛知県'},
        {id: 24, value: '三重県', text: '三重県'},
        {id: 25, value: '滋賀県', text: '滋賀県'},
        {id: 26, value: '京都府', text: '京都府'},
        {id: 27, value: '大阪府', text: '大阪府'},
        {id: 28, value: '兵庫県', text: '兵庫県'},
        {id: 29, value: '奈良県', text: '奈良県'},
        {id: 30, value: '和歌山県', text: '和歌山県'},
        {id: 31, value: '鳥取県', text: '鳥取県'},
        {id: 32, value: '島根県', text: '島根県'},
        {id: 33, value: '岡山県', text: '岡山県'},
        {id: 34, value: '広島県', text: '広島県'},
        {id: 35, value: '山口県', text: '山口県'},
        {id: 36, value: '徳島県', text: '徳島県'},
        {id: 37, value: '香川県', text: '香川県'},
        {id: 38, value: '愛媛県', text: '愛媛県'},
        {id: 39, value: '高知県', text: '高知県'},
        {id: 40, value: '福岡県', text: '福岡県'},
        {id: 41, value: '佐賀県', text: '佐賀県'},
        {id: 42, value: '長崎県', text: '長崎県'},
        {id: 43, value: '熊本県', text: '熊本県'},
        {id: 44, value: '大分県', text: '大分県'},
        {id: 45, value: '宮崎県', text: '宮崎県'},
        {id: 46, value: '鹿児島県', text: '鹿児島県'},
        {id: 47, value: '沖縄県', text: '沖縄県'}
      ],
      list_head: [
        {id: 1, title: '', class: 'th-check'},
        {id: 2, title: '会員ID', class: 'th-id'},
        {id: 3, title: '会員名', class: 'th-name'},
        {id: 4, title: '都道府県', class: 'th-prefecture'},
        {id: 5, title: '最新購入日【経過日数】', class: 'th-last-order-date'},
        {id: 6, title: '最新メール送信日', class: 'th-last-send-date'},
        {id: 7, title: 'メールアドレス', class: 'th-mail'}
      ],
      check_list: [],
      search_customer_id: '',
      search_customer_name: '',
      search_select_not_purchased: 'all',
      search_select_not_mail: 'all',
      search_select_prefecture: 'all',
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    list_all_num () { return this.list.length; },
    search_num () { return this.search_list.length; },
    page_all_num () { return Math.ceil(this.search_list.length / this.step); },
    search_list () {
      return this.list.filter(function(el) {
        this.$store.commit('mCustomerList/set_search_customer_id', this.search_customer_id);
        this.$store.commit('mCustomerList/set_search_customer_name', this.search_customer_name);
        this.$store.commit('mCustomerList/set_search_select_not_purchased', this.search_select_not_purchased);
        this.$store.commit('mCustomerList/set_search_select_not_mail', this.search_select_not_mail);
        this.$store.commit('mCustomerList/set_search_select_prefecture', this.search_select_prefecture);
        if (this.search_customer_id === '' &&
          this.search_customer_name === '' &&
          this.search_select_not_purchased === 'all' &&
          this.search_select_not_mail === 'all' &&
          this.search_select_prefecture === 'all') {
          return true;
        }
        // 会員ID検索
        if (this.search_customer_id !== '' &&
          String(el.id) !== this.search_customer_id) {
          return false;
        }
        // 会員名検索
        if (this.search_customer_name !== '' &&
          String(el.customer_name).indexOf(this.search_customer_name) === -1) {
          return false;
        }
        // 未購入期間検索
        if (this.search_select_not_purchased !== 'all' &&
          el.last_order_date !== '') {
          let date = el.last_order_date.split(' ')[0].replace(/年|月|日/g, '/');
          date = new Date(date);
          let now_date = new Date();
          let days = Math.floor((now_date - date)/1000/60/60/24);
          if (this.search_select_not_purchased === 'one_month') {
            if (days < 30 || days >= 60) {
              return false;
            }
          } else if (this.search_select_not_purchased === 'two_month') {
            if (days < 60 || days >= 90) {
              return false;
            }
          } else if (this.search_select_not_purchased === 'three_month') {
            if (days < 90 || days >= 120) {
              return false;
            }
          } else if (this.search_select_not_purchased === 'four_month') {
            if (days < 120 || days >= 150) {
              return false;
            }
          } else if (this.search_select_not_purchased === 'five_month') {
            if (days < 150 || days >= 180) {
              return false;
            }
          } else {
            if (days < 180) {
              return false;
            }
          }
        }
        // 未送信期間検索
        if (this.search_select_not_mail !== 'all' &&
          el.last_send_mail_date !== '') {
          let date = el.last_send_mail_date.split(' ')[0].replace(/年|月|日/g, '/');
          date = new Date(date);
          let now_date = new Date();
          let days = Math.floor((now_date - date)/1000/60/60/24);
          if (this.search_select_not_mail === 'one_month') {
            if (days < 30 || days >= 60) {
              return false;
            }
          } else if (this.search_select_not_mail === 'two_month') {
            if (days < 60 || days >= 90) {
              return false;
            }
          } else if (this.search_select_not_mail === 'three_month') {
            if (days < 90 || days >= 120) {
              return false;
            }
          } else if (this.search_select_not_mail === 'four_month') {
            if (days < 120 || days >= 150) {
              return false;
            }
          } else if (this.search_select_not_mail === 'five_month') {
            if (days < 150 || days >= 180) {
              return false;
            }
          } else {
            if (days < 180) {
              return false;
            }
          }
        }
        // 都道府県
        if (this.search_select_prefecture !== 'all' &&
          el.prefecture !== '') {
          if (this.search_select_prefecture !== el.prefecture) {
            return false;
          }
        }
        return true;
      }, this);
    },
    page_list () {
      let start_page = (this.page_num - 1) * this.step;
      return this.search_list.slice(start_page, start_page + this.step);
    },
    check_num () {
      this.$store.commit('mCustomerList/set_check_list', this.check_list);
      let counter = 0;
      for(let key in this.check_list) {
        if (this.check_list[key] === true) {
          counter++;
        }
      }
      return counter;
    },
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.current_tab_id = this.$store.getters['mOrderList/selected_tab_id'];
    // 復元データ
    this.search_customer_id = this.$store.getters['mCustomerList/search_customer_id'];
    this.search_customer_name = this.$store.getters['mCustomerList/search_customer_name'];
    this.search_select_not_purchased = this.$store.getters['mCustomerList/search_select_not_purchased'];
    this.search_select_not_mail = this.$store.getters['mCustomerList/search_select_not_mail'];
    this.search_select_prefecture = this.$store.getters['mCustomerList/search_select_prefecture'];
    this.check_list = this.$store.getters['mCustomerList/check_list'];
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
    let ld = new this.$loader(this);
    ld._m_data_set({token: this.$store.getters['mLoginInfo/login_token']});
    ld._post_cb_f = this.order_list_get_cb;
    ld._load_start('manage/customer_list_get.php');
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    tab_click (tab_id) {
      this.current_tab_id = tab_id;
      this.$store.commit('mOrderList/set_selected_tab_id', tab_id);
    },
    order_list_get_cb (data) {
      if (data.res === 1) {
        this.list = data.data.list;
      } else {
        this.$alert('alert', `エラーコード：${data.data.res}`);
      }
    },
    page_change () {
      if (this.page_all_num < this.page_num) {
        this.page_num = this.page_all_num;
      }
    },
    page_shift (num) {
      let check_num = this.$lib._pint(this.page_num) + num;
      if (check_num > 0 && check_num <= this.page_all_num) {
        this.page_num = check_num;
      }
    },
    page_num_check () {
      let shipping_list = this.list.filter(function(el) {
        return el.status == 4;
      }, this);
      let start_page = (this.page_num - 1) * this.step;
      if (shipping_list.length != 0 && start_page >= shipping_list.length) {
        // ステータスの変更で数が変更されるため、このページが表示できるかチェック
        this.page_num = this.page_all_num;
      }
    },
    user_detail_disp (customer_id) {
      this.$router.push({ name: 'mCustomerDetail', params: { id: String(customer_id), type: 1 }});
    },
    date_br (date_str) {
      if (date_str === '') {
        return '';
      }
      let date = date_str.split(' ')[0].replace(/年|月|日/g, '/');
      date = new Date(date);
      let now_date = new Date();
      let days = Math.floor((now_date - date)/1000/60/60/24);
      return date_str.replace(' ', '<br>') + '【' + days + '】';
    },
    check_clear () {
      this.check_list = [];
    },
    mail_send () {
      if (this.check_num === 0) {
        this.$alert('alert', '送信する会員が選択されていません。');
        return;
      }
      // チェックした会員を取得
      let check_customer_list = [];
      for(let key in this.check_list) {
        if (this.check_list[key] === true) {
          check_customer_list.push(this.custer_get_by_id(key));
        }
      }
      // storeに保存
      this.$store.commit('mCustomerList/set_check_customer_list', check_customer_list);

      this.$router.push({path: '/manage/customer_mail'});
    },
    custer_get_by_id (id) {
      let i;
      let len = this.list.length;
      let res_data = {};
      for (i = 0; i < len; i++) {
        if (String(this.list[i].id) === String(id)) {
          res_data = this.list[i];
        }
      }
      return res_data;
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.manage-default-box {
  .main-box {
    display: flex;
  }
  .customer-list-box {
    min-width: 1108px;
    flex: 1;
    padding: 16px;
    .search-box {
      margin: 20px auto 0 auto;
      padding: 10px 0;
      background-color: #f4f4e5;
      display: flex;
      width: 1100px;
      .title {
        width: 70px;
        font-size: 1.1rem;
        text-align: center;
        font-weight: bold;
        color: #767970;
        line-height: 1.2;
      }
      .search-content-box {
        width: 1030px;
      }
      .search-sub-box {
        display: flex;
        justify-content: flex-start;
      }
      dl {
        display: flex;
        margin-bottom: 3px;
      }
      dt {
        width: 110px;
        height: 32px;
        line-height: 32px;
        box-sizing: border-box;
        border-left: 6px solid #738f53;
        font-size: 1.1rem;
        padding-left: 10px;
        text-align: left;
        margin-left: 10px;
      }
      dt.select-not-purchased {
      }
      dd {
        text-align: left;
        font-weight: bold;
        box-sizing: border-box;
        padding: 0 10px;
        width: 230px;
        height: 32px;
        line-height: 32px;
      }
      select.select-not-purchased {
        width: 160px;
        height: 26px;
      }
    }
    .customer-info-box {
      max-width: 1500px;
      margin: 30px auto 5px auto;
      height: 32px;
      display: flex;
      justify-content: space-between;
      .button {
        text-decoration: underline;
        color: #9c5360;
        background-color: transparent;
        font-size: 1rem;
        font-weight: normal;
        margin-left: 20px;
        cursor: pointer;
      }
      .button:hover {
        color: #e91f42;
      }
      .num-box {
        display: flex;
        align-items: center;
        margin-left: 10px;
        color: #767970;
        font-weight: bold;
        font-size: 1.2rem;
        .customers-num-box {
          width: 210px;
          display: flex;
          align-items: center;
        }
        .title {
        }
        .num-info {
        }
      }
      .paging-box {
        width: 250px;
        display: flex;
        justify-content: center;
        align-items: center;
        input[type="text"] {
          text-align: right;
          height: 30px;
          width: 40px;
        }
        div {
          padding: 0 25px;
          margin: 0 10px;
          height: 30px;
          line-height: 32px;
          text-align: center;
          background-color: #cfcebc;
          border-radius: 5px;
          color: #FFF;
          font-weight: bold;
          cursor: pointer;
        }
        div:hover {
          background-color: #738f53;
        }
      }
    }
    .list-box {
      max-width: 1500px;
      margin: 0 auto;
      table {
        width: 100%;
        thead {
          display:block;
          padding-right: 17px;
          tr {
            background-color: $manage-table-head-bg-color;
          }
          th {
            border: 1px solid $manage-table-border-color;
            border-bottom: none;
            padding: 5px 0;
          }
          th.th-check {
            min-width: 50px;
          }
          th.th-id {
            min-width: 80px;
          }
          th.th-name {
            min-width: 200px;
            padding: 0 10px;
          }
          th.th-prefecture {
            min-width: 90px;
          }
          th.th-last-order-date {
            min-width: 200px;
          }
          th.th-last-send-date {
            min-width: 150px;
          }
          th.th-mail {
            width: 9999px;
            padding: 0 10px;
          }
        }
        tbody{
          display:block;
          overflow-y:scroll;
          height: calc(100vh - 285px);
          min-height: 320px;
          tr.unsubscribe {
            background-color: #efefef;
          }
          td {
            border: 1px solid $manage-table-border-color;
            vertical-align: middle;
          }
          td.td-check {
            min-width: 50px;
            input[type="checkbox"] + label::before {
              top: 1px;
            }
            label {
              padding-left: 0;
            }
          }
          td.td-id {
            min-width: 80px;
          }
          td.td-name {
            min-width: 200px;
            text-align: left;
            padding: 0 10px;
            div {
              cursor: pointer;
              text-decoration: underline;
              width: fit-content;
              color: #9c5360;
            }
            div:hover {
              color: #e91f42;
            }
          }
          td.td-prefecture {
            min-width: 90px;
          }
          td.td-last-order-date {
            padding: 5px 0;
            min-width: 200px;
          }
          td.td-last-send-date {
            padding: 5px 0;
            min-width: 150px;
          }
          td.td-mail {
            width: 9999px;
            text-align: left;
            padding: 0 10px;
            word-break: break-all;
          }
        }
      }
    }
  }
}
</style>
